import React, { FormEvent } from 'react';
import { Button, TextField, styled } from '@mui/material';
import { Search } from '@mui/icons-material';
import { PaymentMethodQueryParams } from './hooks/useFetchPaymentMethods';
import FilterBox from 'components/filter-box/FilterBox';

const Filter = styled('form')(({ theme }) => ({
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: '300px 100px',
  columnGap: 10,
  rowGap: 15,
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

type PaymentMethodFilterBoxProps = {
  filter: PaymentMethodQueryParams;
  handleChange(index: keyof PaymentMethodQueryParams, value: any): void;
  handleSearch(e?: FormEvent<HTMLFormElement>): void;
  loading: boolean;
};

const PaymentMethodFilterBox: React.FC<PaymentMethodFilterBoxProps> = ({
  filter,
  loading,
  handleChange,
  handleSearch,
}) => {
  return (
    <FilterBox>
      <Filter onSubmit={handleSearch}>
        <TextField
          fullWidth
          label="Nome"
          placeholder="Digite o nome da forma de pagamento"
          value={filter.name}
          autoFocus
          onChange={e => handleChange('name', e.target.value)}
        />

        <Button
          type="submit"
          disabled={loading}
          variant="contained"
          color="primary"
          size="small"
          startIcon={<Search />}
        >
          Buscar
        </Button>
      </Filter>
    </FilterBox>
  );
};

export default PaymentMethodFilterBox;
